<template>
	<div class="container">
		<div class="sub_top">
			<div class="top_content">
				<div class="headline">
					<p class="sub_title">
						{{ $t('rtr_business-how-receive.title1') }}<br />
						{{ $t('rtr_business-how-receive.title2') }}
					</p>
					<div class="button_area">
						<button
							class="button_bg_red mr_10"
							@click="$router.push({ name: 'auth-register' })"
						>
							{{ $t('button.signup') }}
						</button>
						<button
							class="button_bg_white"
							@click="$router.push({ name: 'cs' })"
						>
							{{ $t('button.info') }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<section>
			<div class="sub_middle">
				<router-link :to="{ name: 'cs' }" class="link_type_02 text fc_white">
					{{ $t('rtr_business-how-receive.text1') }}
					<span class="CIRCLE_ARROW type_01"></span>
				</router-link>
			</div>
			<div class="sub_bottom">
				<h2 class="title">
					{{ $t('rtr_business-how-receive.title3') }}
				</h2>
				<p class="text">
					{{ $t('rtr_business-how-receive.text2') }}
				</p>
			</div>
		</section>
		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_business-how-receive.title4') }}
							</h2>
							<p class="text">
								{{ $t('rtr_business-how-receive.text3') }}<br />
								{{ $t('rtr_business-how-receive.text4') }}
							</p>
						</div>
					</div>
					<div class="img_area">
						<img src="@/assets/images/sub/business_receive_02.png" alt="" />
					</div>
				</div>
			</div>
		</section>
		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="img_area">
						<img src="@/assets/images/sub/business_receive_03.png" alt="" />
					</div>
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_business-how-receive.title5') }}
							</h2>
							<p class="text">
								{{ $t('rtr_business-how-receive.text5') }}<br />
								{{ $t('rtr_business-how-receive.text6') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_business-how-receive.title6') }}
							</h2>
							<p class="text">
								{{ $t('rtr_business-how-receive.text7') }}<br />
								{{ $t('rtr_business-how-receive.text8') }}
								{{ $t('rtr_business-how-receive.text9') }}
								{{ $t('rtr_business-how-receive.text10') }}<br />
								{{ $t('rtr_business-how-receive.text11') }}
							</p>
						</div>
					</div>
					<div class="img_area">
						<img src="@/assets/images/sub/business_receive_04.png" alt="" />
					</div>
				</div>
			</div>
		</section>

		<section class="bg_gray">
			<div class="sub_content">
				<div class="sub_content_area">
					<div class="sub_content_box">
						<div class="img_box">
							<img src="@/assets/images/sub/business_receive_05.png" alt="" />
						</div>
						<div class="detail_box">
							<h2 class="detail_title">
								{{ $t('rtr_business-how-receive.title7') }}
							</h2>
							<p class="detail_text">
								{{ $t('rtr_business-how-receive.text12') }}
								{{ $t('rtr_business-how-receive.text13') }}
							</p>
							<div class="d_flex">
								<router-link
									to
									class="link_type_03 text_wrap mr_10 align_items_start"
									@click="notYet"
								>
									<span>{{ $t('rtr_business-how-receive.text14') }}</span>
									<span class="CIRCLE_ARROW type_02"></span>
								</router-link>
								<router-link
									to
									class="link_type_03 text_wrap align_items_start"
									@click="notYet"
								>
									<span>{{ $t('rtr_business-how-receive.text15') }}</span>
									<span class="CIRCLE_ARROW type_02"></span>
								</router-link>
							</div>
						</div>
					</div>
					<div class="sub_content_box">
						<div class="img_box">
							<img src="@/assets/images/sub/business_receive_08.png" alt="" />
						</div>
						<div class="detail_box">
							<h2 class="detail_title">
								{{ $t('rtr_business-how-receive.title8') }}
							</h2>
							<p class="detail_text">
								{{ $t('rtr_business-how-receive.text16') }}
								{{ $t('rtr_business-how-receive.text17') }}
							</p>
							<router-link to class="link_type_03" @click="notYet">
								{{ $t('rtr_business-how-receive.text18')
								}}<span class="CIRCLE_ARROW type_02"></span>
							</router-link>
						</div>
					</div>
				</div>
				<div class="sub_content_area">
					<div class="sub_content_box">
						<div class="img_box">
							<img src="@/assets/images/sub/business_receive_06.png" alt="" />
						</div>
						<div class="detail_box">
							<h2 class="detail_title">
								{{ $t('rtr_business-how-receive.title9') }}
							</h2>
							<p class="detail_text">
								{{ $t('rtr_business-how-receive.text19') }}
								{{ $t('rtr_business-how-receive.text20') }}
							</p>
							<router-link to class="link_type_03" @click="notYet">
								{{ $t('rtr_business-how-receive.text21')
								}}<span class="CIRCLE_ARROW type_02"></span>
							</router-link>
						</div>
					</div>
					<div class="sub_content_box">
						<div class="img_box">
							<img src="@/assets/images/sub/business_receive_09.png" alt="" />
						</div>
						<div class="detail_box">
							<h2 class="detail_title">
								{{ $t('rtr_business-how-receive.title10') }}
							</h2>
							<p class="detail_text">
								{{ $t('rtr_business-how-receive.text22') }}<br />
								{{ $t('rtr_business-how-receive.text23') }}
							</p>
						</div>
					</div>
				</div>
				<div class="sub_content_area">
					<div class="sub_content_box">
						<div class="img_box">
							<img src="@/assets/images/sub/business_receive_07.png" alt="" />
						</div>
						<div class="detail_box">
							<h2 class="detail_title">
								{{ $t('rtr_business-how-receive.title11') }}
							</h2>
							<p class="detail_text">
								{{ $t('rtr_business-how-receive.text24') }}<br />
								<span
									><router-link to class="link_type_03 fs_14" @click="notYet">
										{{ $t('rtr_business-how-receive.text25') }}
									</router-link></span
								>
								{{ $t('rtr_business-how-receive.text26') }}
							</p>
						</div>
					</div>
					<div class="sub_content_box">
						<div class="img_box">
							<img src="@/assets/images/sub/business_receive_10.png" alt="" />
						</div>
						<div class="detail_box">
							<h2 class="detail_title">
								{{ $t('rtr_business-how-receive.title12') }}
							</h2>
							<p class="detail_text">
								{{ $t('rtr_business-how-receive.text27') }}<br />
								{{ $t('rtr_business-how-receive.text28') }}
							</p>
							<router-link to class="link_type_03" @click="notYet">
								{{ $t('rtr_business-how-receive.text29')
								}}<span class="CIRCLE_ARROW type_02"></span>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'Receive',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>

<style scoped></style>
